var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fas fa-chevron-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }